// revolutionApi.js

import { uploadToS3 } from "../utils/uploadToS3";
import api from "./axios";

export const revolutionApi = {
  createRevolution: async ({
    title,
    description,
    images = [],
    pdf = null,
    onUploadProgress,
    signal,
  }) => {
    const hasPdf = !!pdf;
    const totalUnits = images.length + (hasPdf ? 1 : 0);

    // Per-unit progress (0-100 each), combined into one overall percentage.
    const unitProgress = new Array(totalUnits).fill(0);

    const reportOverall = () => {
      if (totalUnits === 0) return;
      const sum = unitProgress.reduce((a, b) => a + b, 0);
      const overall = Math.round(sum / totalUnits);
      onUploadProgress?.(overall);
    };

    //
    // Upload Images (parallel, each tracked independently)
    //
    const imageUploadPromises = images.map((file, i) =>
      uploadToS3({
        file,
        mediaType: "image",
        signal,
        onProgress: (percent) => {
          unitProgress[i] = percent;
          reportOverall();
        },
      }).catch((error) => {
        throw new Error(
          `Failed to upload image ${i + 1} of ${images.length}: ${error.message}`,
        );
      }),
    );

    //
    // Upload PDF (alongside images, not after them)
    //
    const pdfUnitIndex = images.length;
    const pdfUploadPromise = hasPdf
      ? uploadToS3({
          file: pdf,
          mediaType: "pdf",
          // NOTE: confirm with backend whether /media/presign accepts "pdf"
          // as a valid mediaType — if it validates against an enum of
          // image/video only, this will be rejected or misfiled.
          signal,
          onProgress: (percent) => {
            unitProgress[pdfUnitIndex] = percent;
            reportOverall();
          },
        }).catch((error) => {
          throw new Error(`Failed to upload PDF: ${error.message}`);
        })
      : Promise.resolve(null);

    let imageKeys, pdfKey;
    try {
      [imageKeys, pdfKey] = await Promise.all([
        Promise.all(imageUploadPromises),
        pdfUploadPromise,
      ]);
    } catch (error) {
      // Re-throw with clear context; any already-uploaded files in this
      // batch remain in S3 but are not referenced by any revolution yet.
      throw new Error(
        `Upload failed, revolution not created: ${error.message}`,
      );
    }

    //
    // Create revolution
    //
    try {
      const res = await api.post("/revolution", {
        title,
        description,
        images: imageKeys,
        pdf: pdfKey,
      });

      return res.data;
    } catch (error) {
      throw new Error(
        `Files uploaded but failed to create revolution: ${
          error.response?.data?.message || error.message
        }`,
      );
    }
  },

  /* ===================== GET SINGLE REVOLUTION (Shared Revolution) ===================== */
  getRevolutionById: async ({ revolutionId }) => {
    if (!revolutionId) {
      throw new Error("revolutionId is required");
    }

    const res = await api.get(`/revolution/${revolutionId}`);

    return res.data;
  },
};

// ============================================================================================================

// import api from "./axios";

// export const revolutionApi = {
//  createRevolution: async (formData, onUploadProgress) => {
//    const res = await api.post("/revolution", formData, {
//      headers: {
//        "Content-Type": "multipart/form-data",
//      },
//      onUploadProgress: onUploadProgress
//        ? (progressEvent) => {
//            const percent = Math.round(
//              (progressEvent.loaded * 100) / progressEvent.total,
//            );
//            onUploadProgress(percent);
//          }
//        : undefined,
//    });

//    return res.data;
//  },

//  /* ===================== GET SINGLE REVOLUTION (Shared Revolution) ===================== */
//  getRevolutionById: async ({ revolutionId }) => {
//    if (!revolutionId) {
//      throw new Error("postId is required");
//    }

//    const res = await api.get(`/revolution/${revolutionId}`);

//    return res.data;
//  },
// };

/* ===================== Direct S3 Upload  ===================== */

// import { uploadToS3 } from "../utils/uploadToS3";
// import api from "./axios";

// export const revolutionApi = {
//   createRevolution: async ({
//     title,
//     description,
//     images = [],
//     pdf = null,
//     onUploadProgress,
//   }) => {
//     const imageKeys = [];

//     //
//     // Upload Images
//     //
//     for (let i = 0; i < images.length; i++) {
//       const key = await uploadToS3({
//         file: images[i],
//         mediaType: "image",

//         onProgress: (percent) => {
//           const overall = Math.round(
//             ((i + percent / 100) / images.length) * 100,
//           );

//           onUploadProgress?.(overall);
//         },
//       });

//       imageKeys.push(key);
//     }

//     //
//     // Upload PDF
//     //
//     let pdfKey = null;

//     if (pdf) {
//       pdfKey = await uploadToS3({
//         file: pdf,
//         mediaType: "pdf",

//         onProgress: (percent) => {
//           onUploadProgress?.(percent);
//         },
//       });
//     }

//     //
//     // Create revolution
//     //
//     const res = await api.post("/revolution", {
//       title,
//       description,
//       images: imageKeys,
//       pdf: pdfKey,
//     });

//     return res.data;
//   },

//   /* ===================== GET SINGLE REVOLUTION (Shared Revolution) ===================== */
//   getRevolutionById: async ({ revolutionId }) => {
//     if (!revolutionId) {
//       throw new Error("postId is required");
//     }

//     const res = await api.get(`/revolution/${revolutionId}`);

//     return res.data;
//   },
// };
